import type { ShareDealDialogStickerConfig } from '.';

export function hasLeaseTermAndMileageError(
  config: ShareDealDialogStickerConfig<any, any>,
): boolean {
  if (!config.includeWhenSending) {
    return false;
  }
  const hasSelectedMileage = config.selectedOffers.leaseMileages.length > 0;
  const hasSelectedTerm = config.selectedOffers.leaseTerms.length > 0;
  return hasSelectedMileage !== hasSelectedTerm;
}
